import React from 'react';
import { Instagram, Linkedin, Mail } from 'lucide-react';
import { Footer as UiFooter } from '../ui/footer';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <UiFooter
      logo={<img src="/images/generalimg/1.svg" alt="Project Level the Field logo" className="h-10 w-10" />}
      brandName="Project Level the Field"
      socialLinks={[
        {
          icon: <Instagram className="h-5 w-5" />,
          href: 'https://www.instagram.com/levelthefieldnationals/',
          label: 'Instagram',
        },
        {
          icon: <Linkedin className="h-5 w-5" />,
          href: 'https://www.linkedin.com/company/project-level-the-field/',
          label: 'LinkedIn',
        },
        {
          icon: <Mail className="h-5 w-5" />,
          href: 'mailto:staff@projectlevelthefield.com',
          label: 'Email',
        },
      ]}
      mainLinks={[
        { href: '/about', label: 'Leadership' },
        { href: '/chapters', label: 'Chapters' },
        { href: '/statistics', label: 'Statistics' },
        { href: '/news', label: 'News' },
        { href: '/contact', label: 'Contact' },
      ]}
      legalLinks={[
        { href: '/programs', label: 'Programs' },
        { href: '/partnerships', label: 'Partnerships' },
      ]}
      copyright={{
        text: `© ${year} Project Level the Field`,
        license: '501(c)(3) nonprofit organization',
      }}
    />
  );
};

export default Footer;
